import MenuAuthoring from 'images/menu-authoring.svg'
import MenuArchitecture from 'images/menu-architecture.svg'
import MenuSourcing from 'images/menu-sourcing.svg'
import MenuTopics from 'images/menu-topics.svg'
import MenuFiles from 'images/menu-files.svg'
import MenuQuestionGenerator from 'images/menu-question-generator.svg'
import MenuReview from 'images/menu-review.svg'
import MenuMedia from 'images/menu-media.svg'
import MenuGrades from 'images/menu-upload-grades.svg'
import MenuContentFinder from 'images/menu-images.svg'
import { Role } from 'providers/CompositeAuthProvider'

interface MenuItem {
  title: string
  path: string
  icon: string
}

const Path = {
  root: { title: 'Home', path: '/' } as MenuItem,
  error: { title: 'Error', path: '/error' } as MenuItem,
  contentFinder: {
    title: 'Content finder',
    path: '/content-finder',
    icon: MenuContentFinder,
  } as MenuItem,
  architectures: {
    title: 'Architectures',
    path: '/architectures',
    icon: MenuArchitecture,
  } as MenuItem,
  authoring: {
    title: 'Authoring',
    path: '/authoring',
    icon: MenuAuthoring,
  } as MenuItem,
  sourcing: {
    title: 'Sourcing',
    path: '/sourcing',
    icon: MenuSourcing,
  } as MenuItem,
  files: {
    title: 'Files (deprecated)',
    path: '/files',
    icon: MenuFiles,
  } as MenuItem,
  topics: {
    title: 'Topics',
    path: '/topics',
    icon: MenuTopics,
  } as MenuItem,
  mediaPage: {
    title: 'Media',
    path: '/media',
    icon: MenuMedia,
  } as MenuItem,
  // [NOT USED]
  questionGenerator: {
    title: 'Question generator',
    path: '/question-generator',
    icon: MenuQuestionGenerator,
  } as MenuItem,
  quizzes: {
    title: 'Quizzes',
    path: '/quizzes',
    icon: MenuReview,
  } as MenuItem,
  grades: {
    title: 'Grades',
    path: '/upload-grades',
    icon: MenuGrades,
  } as MenuItem,
}

// Route configurations with allowed roles
export const RouteConfig: Record<string, Role[]> = {
  [Path.root.path]: [], // No role restriction
  [Path.error.path]: [], // No role restriction
  [Path.contentFinder.path]: [
    Role.Admin,
    Role.SuperAdmin,
    Role.Author,
    Role.Designer,
    Role.Contractor,
  ],
  [Path.architectures.path]: [Role.Admin, Role.SuperAdmin, Role.Author],
  [Path.authoring.path]: [
    Role.Admin,
    Role.SuperAdmin,
    Role.Author,
    Role.Designer,
    Role.Contractor,
  ],
  [Path.topics.path]: [
    Role.Admin,
    Role.SuperAdmin,
    Role.Author,
    Role.Designer,
    Role.Contractor,
  ],
  [Path.mediaPage.path]: [
    Role.Admin,
    Role.SuperAdmin,
    Role.Author,
    Role.Designer,
    Role.Contractor,
  ],
  [Path.quizzes.path]: [Role.Admin, Role.SuperAdmin, Role.Author],
  [Path.questionGenerator.path]: [Role.SuperAdmin],
  [Path.grades.path]: [Role.Admin, Role.SuperAdmin, Role.Author], // Temporary allow Author role
}

// Get menu items for a specific role
export const getMenuForRole = (role: Role): MenuItem[] => {
  const allMenuItems = [
    Path.contentFinder,
    Path.architectures,
    Path.authoring,
    Path.mediaPage,
    Path.topics,
    Path.quizzes,
    Path.grades,
  ]

  return allMenuItems.filter((item) => {
    const allowedRoles = RouteConfig[item.path]
    return (
      !allowedRoles || allowedRoles.length === 0 || allowedRoles.includes(role)
    )
  })
}

// Get allowed roles for a specific path
export const getAllowedRolesForPath = (path: string): Role[] => {
  // Check for exact match first
  if (RouteConfig[path]) {
    return RouteConfig[path]
  }

  // Check for parent paths (e.g., /quizzes/123 -> /quizzes)
  const parentPath = Object.keys(RouteConfig).find(
    (configPath) => configPath !== '/' && path.startsWith(configPath),
  )

  return parentPath ? RouteConfig[parentPath] : []
}

export default Path
